import { createFileRoute } from '@tanstack/react-router';

import {
  ResetPasswordPage as SharedResetPasswordPage,
  verifyResetToken,
} from '@/routes/-components/reset-password-page';

import { ResearcherRightPanel } from '../-auth/right-panel';

export const Route = createFileRoute('/researchers/reset-password/$token')({
  beforeLoad: async ({ params }) => {
    const result = await verifyResetToken({
      data: { token: params.token },
    });
    return { tokenValid: result.valid };
  },
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { tokenValid } = Route.useRouteContext();
  const params = Route.useParams();

  return (
    <SharedResetPasswordPage
      token={params.token}
      tokenValid={tokenValid}
      loginPath="/researchers/login"
      rightPanel={<ResearcherRightPanel />}
      successIconClassName="text-fg-success-primary"
    />
  );
}
